import { map } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { Source } from './../../_models/alert/common/common/source';
import { AppState } from '../../_reducers';
import { AlertGroup } from '../../_models/alert/alertGroup';
import { environment } from '../../../../environments/environment';
import { MappingService } from '../mapping.service';
import { selectAllAlertGroups } from '../../_selectors/alertGroup.selectors';

@Injectable()
export class AlertGroupService {
  alertTypes = Source;
  private apiBaseUrl = environment.apiBaseUrl;
  alertGroupItemObj: BehaviorSubject<AlertGroup> = new BehaviorSubject<AlertGroup>(null);
  currentTab$: BehaviorSubject<string> = new BehaviorSubject<string>('step1');
  hideBottomBar$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  disableButton$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  inEditSummary$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private types: any = null;
  private alertGroupList$: Observable<AlertGroup[]>;

  constructor(
    private http: HttpClient,
    private mappingService: MappingService,
    private store: Store<AppState>
  ) {
    this.alertGroupList$ = this.store.pipe(select(selectAllAlertGroups));
  }

  getFromLocalStore(): Observable<AlertGroup[]> {
    return this.alertGroupList$;
  }

  initAlertGroupItemObj() {
    this.alertGroupItemObj = new BehaviorSubject<AlertGroup>(null);
  }

  setAlertGroupItemObj(alertGroup: AlertGroup) {
    this.alertGroupItemObj.next(alertGroup);
  }

  get getAlertGroupItemObj() {
    return this.alertGroupItemObj.asObservable();
  }

  initCurrentTab() {
    this.currentTab$ = new BehaviorSubject<any>('step1');
  }

  setCurrentTab(tab) {
    this.currentTab$.next(tab);
  }

  getCurrentTab() {
    return this.currentTab$.asObservable();
  }

  initBottomBar() {
    this.hideBottomBar$ = new BehaviorSubject<boolean>(false);
  }

  setBottomBar(bool) {
    this.hideBottomBar$.next(bool);
  }

  getBottomBar() {
    return this.hideBottomBar$.asObservable();
  }

  initDisableButton() {
    this.disableButton$ = new BehaviorSubject<boolean>(false);
  }

  setDisableButton(bool) {
    this.disableButton$.next(bool);
  }

  getDisableButton() {
    return this.disableButton$.asObservable();
  }

  initInEditSummary() {
    this.inEditSummary$ = new BehaviorSubject<boolean>(false);
  }

  setInEditSummary(bool) {
    this.inEditSummary$.next(bool);
  }

  getInEditSummary() {
    return this.inEditSummary$.asObservable();
  }

  getAlertGroups(): Observable<AlertGroup[]> {
    return this.http
      .get<AlertGroup[]>(this.apiBaseUrl + 'api/private/v1/alerts')
      .pipe(map((response) => response));
  }
  getAlertGroup(id: number): Observable<AlertGroup> {
    return this.http
      .get<AlertGroup>(this.apiBaseUrl + 'api/private/v1/alerts/' + id)
      .pipe(map((response) => response));
  }
  saveAlertGroup(alertGroupItem): Observable<any> {
    const alertGroup = { ...alertGroupItem };
    delete alertGroup.param;
    delete alertGroup.period;
    delete alertGroup.companyId;
    delete alertGroup.value;
    delete alertGroup.createdAt;

    if (alertGroup.id) {
      return this.http
        .put<any>(this.apiBaseUrl + 'api/private/v1/alerts/' + alertGroup.id, alertGroup)
        .pipe(
          map((response) => {
            return alertGroup;
          })
        );
    } else {
      return this.http
        .post<any>(this.apiBaseUrl + 'api/private/v1/alerts', alertGroup)
        .pipe(map((response) => response));
    }
  }

  deleteAlertGroup(id: number): Observable<AlertGroup> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/alerts/' + id).pipe(
      map((response) => {
        return { id } as AlertGroup;
      })
    );
  }

  getAlertGroupPathogen(): Observable<any> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/getPathogens')
      .pipe(map((response) => response));
  }

  getAlertTemplates(): Observable<AlertGroup[]> {
    return this.http
      .get<AlertGroup[]>(this.apiBaseUrl + 'api/private/v1/alerts/templates')
      .pipe(map((response) => response));
  }

  getImageByType(type: string): string {
    let response = '';
    this.mappingService.list.subscribe((resp) => {
      if (resp && resp.alert) {
        this.types = resp.alert;
        if (this.types.types && this.types.types.length > 0) {
          const index = this.types.types.findIndex((chr) => chr.name === type);
          if (index >= 0) {
            response = this.types.types[index].imgUrl;
          } else {
            const indexTMP = this.types.types.findIndex((chr) => chr.name === 'AndOr');
            response = this.types.types[indexTMP].imgUrl;
          }
        }
      }
    });
    return response;
  }

  getImageByTypeBackend(type: string): string {
    let response = '';
    this.mappingService.list.subscribe((resp) => {
      if (resp && resp.alert) {
        this.types = resp.alert;
        if (this.types.types && this.types.types.length > 0) {
          const index = this.types.types.findIndex((chr) => chr.type === type);
          if (index >= 0) {
            response = this.types.types[index].imgUrl;
          } else {
            const indexTMP = this.types.types.findIndex((chr) => chr.name === 'AndOr');
            response = this.types.types[indexTMP].imgUrl;
          }
        }
      }
    });
    return response;
  }
}
